import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

export default function RequireOta({ children }) {
  const host = useSelector((s) => s.host.hostInfo);
  const enabled =
    host?.ota === true || host?.features?.ota === true || host?.flags?.ota === true;

  const location = useLocation();
  if (!enabled) {
    return <Navigate to="/host" replace state={{ from: location, code: 403 }} />;
  }
  return children;
}
